<div class="due-date-wrapper d-flex-center">
  <mat-icon [svgIcon]="'clock'" class="due-date-icon mr-1"></mat-icon>{{task.dueDate | date: DATE_FORMAT_SHORT}}
</div>
